<template>
  <div id="q-app">
    <router-view />
  </div>
</template>
<script>
export default {}
</script>
<style src="./waste.scss" lang="scss">

</style>
